/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/updateProfile.config.json";

import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { UPDATE_MY_ORGANIZATION } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateProfileMethods extends IPluginMethodMap {
  getUpdateProfile(args: any): Promise<any>;
}

export interface UpdateProfileProps {
  name: string;
  description: string;
  telephone: string;
  address: string;
  website: string;
  logo?: any;
  city?: string;
  country?: string;
}

export class UpdateProfileService implements IAgentPlugin {
  readonly methods: IUpdateProfileMethods;

  constructor() {
    this.methods = {
      getUpdateProfile: this.getUpdateProfile.bind(this),
    };
  }

  async getUpdateProfile(args: UpdateProfileProps) {
    console.log(`profile data inside mutation`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const storageSrv = StorageModule?.getInstance();

    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_MY_ORGANIZATION,
          variables: {
            input: {
              name: args?.name,
              description: args?.description,
              primaryContactNo: args?.telephone,
              website: args?.website,
              address: {
                addressLine1: args?.address,
                city: args?.city,
                country: args?.country,
              },
              logo: args?.logo?.base64,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          storageSrv?.remove("myProfile", "session");
          return {
            data: res?.data,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
